import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'

const CopyLinkMenuItem = () => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    navigator.clipboard.writeText(window.location.href).then(function() {
      toastr.success(formatMessage(messages.copyLinkSuccess))
    }, function(err) {
      toastr.error(err)
    })
  }

  return (
    <Menu.Item>
      {(props) => (
        <MenuButton {...props} onClick={onClick}>
          { formatMessage(messages.copyLink) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default CopyLinkMenuItem
